export const PERMISSION_INDICATOR_PILL_TYPES = {
  EMPTY: 'empty',
  SEMI: 'semi',
  FULL: 'full',
};

export const PERMISSION_MENU_ITEM_SIZES = {
  NORMAL: 'normal',
  SMALL: 'small',
};
